import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";
import { getData } from "src/utils/axios/serverHelper";

const productWorkUrl = `${config.apiUrl}/productWork`;

/**
 * 공정작업 모달용 목록 조회
 * @param searchText 검색어
 * @param workplaceCd 작업장코드
 * @param closeTag 마감여부
 * @returns 공정작업 목록
 */
export const getProductWorkPopupList = async (
    searchText: string,
    workplaceCd?: string,
    closeTag?: string
) => {
    const url = `${productWorkUrl}/PRD2040_R01/list`;
    
    return await getData<ResponseDto<ProductWorkDto[]>>(url, {
        params: {
            searchText: searchText || '',
            workplaceCd: workplaceCd || '',
            closeTag: closeTag || 'N'
        }
    });
};
